<!-- 我的游戏币 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" width="32" alt=""></div>
        
        <div class="title-text">
            <div class="main"><img :src="require('../assets/my-coin.png')" alt="" height="24"></div>
            <div class="subf"><img :src="require('../assets/gold-2.png')" alt="" height="16"></div>
            <div class="coin-count">{{user['coin']}}</div>
        </div>
        <ul class="list" v-loading="pageLoading">
            <li v-for="item in list" :key="item.id">
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">{{item.title}}</div>
                        <div class="cont integral win" v-if="item.delta >0 ">+{{item.delta}}</div>
                        <div class="cont integral default" v-if="item.delta < 0">{{item.delta}}</div>
                    </div>
                   <!--  <div class="desc win ">{{item.time|  torontoTimeFormat('YYYY.MM.DD')}}{{item.team1}} VS {{item.team2}}</div> -->
                    <div class="cont-row desc">
                        <div class="flex-cont">{{item.content}}</div>
                        <div class="cont">余额：{{item.balance}}</div>
                    </div>
                  <!--   <div class="desc">{{item.content}}</div> -->
                </div>
            </li>
            <!-- <li>
                <div class="tag"><img :src="require('../assets/xunzhang.png')" alt=""></div>
                <div class="flex-cont">
                    <div class="cont-row">
                        <div class="flex-cont result">竞猜胜利</div>
                        <div class="cont integral default">-200</div>
                    </div>
                    <div class="desc ">11月21日法国 VS 澳大利亚</div>
                </div>
            </li> -->
            <!-- <li v-if="list.length==0" class="nodata">暂无相关数据</li> -->
        </ul>
    </div>
</el-dialog>
</template>
<script>
/**
 * type 2 赢 3输
 *
 */
export default {
    name :'MyGameMoney',
    props:['status'],
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    data(){
        return {
            pageLoading:false,
            list:[]
        }
    },
    
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        },
        async getList(){
            this.pageLoading = true;
            let result = await this.$axios.get('/worldcup2022/game/coin/my/flow/list')
            this.pageLoading = false;
            if( result.code == 0){
                this.list = result.data.flows;
            }
            console.log('liushui====》',result);
        }
    },
    watch:{
        status(val){
            if(val){
                this.getList()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:380px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%}
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; background-size: 100%; padding:15px; position: relative; border-radius: 10px;
    .title-text{
        display: flex; align-items: center; padding: 5px 0 19px;
        .main{margin-right: 10px;}
        .subf{margin-right: 2px;}
        .coin-count{font-size: 16px; line-height: 24px; font-weight: bold; color: #fff;}
    }
    .win-cup{position: absolute; right: 70px; top: -31px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.list{
    padding:30px 12px 10px; background: #fff; border-radius: 10px; max-height: 480px; overflow-y:auto;
    li{
        display: flex; align-items: flex-start; padding-bottom: 12px; margin-bottom: 15px; border-bottom: 1px solid #eee;
        .tag{margin-right: 15px;}
        .result{font-size: 16px; line-height: 24px; font-weight: 600;}
        .integral{
            font-size: 14px; line-height: 20px; font-weight: 500;
            &.win{color: #FF5108;}
            &.default{color: #00AA5E;}
        }
        .desc{font-size: 12px; line-height: 18px; color: #999;}
        &.nodata{text-align: center; color: #999; justify-content: center;}
    }
}
</style>